import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const container = document.getElementById('root');

// Catalogue pages are prerendered with the print record that produced their
// visible HTML. Capture it before a clean client mount replaces that markup,
// so the first React render can reproduce the page instead of flashing a
// generic loading skeleton with a different aspect ratio.
const prerenderedPrintData = container.querySelector(
  '#create-prints-print-data'
);
if (prerenderedPrintData?.textContent) {
  try {
    window.__CREATE_PRINTS_INITIAL_PRINT_DATA__ = JSON.parse(
      prerenderedPrintData.textContent
    );
  } catch {
    // A stale or malformed hint should fall back to the normal API request.
  }
}

const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// The homepage is deliberately rendered without a Suspense boundary and its
// prerender data is held at deterministic initial states, so React can attach
// without discarding the hero (the LCP candidate). Other prerendered routes
// can include lazy-route Suspense state captured from the browser, which is not
// valid server-renderer output; those routes use a clean client mount instead.
const canHydrateHomepage =
  container.hasChildNodes() && window.location.pathname === "/";

if (canHydrateHomepage) {
  ReactDOM.hydrateRoot(container, app, {
    onRecoverableError(error, errorInfo) {
      console.error("React hydration error", error, errorInfo?.componentStack);
    },
  });
} else {
  container.replaceChildren();
  ReactDOM.createRoot(container).render(app);
}
